import React, {Component} from 'react'
import {observer} from 'mobx-react'

import TagSourceField from '../../struct/TagSourceField'
import Hint from '../../struct/Hint'
import SettingsGroup from '../../struct/SettingsGroup'
import InputText from '../../control/DependentInputText'
import DependentCheckbox from "../../control/DependentCheckbox"

@observer export default class ProfileShopSettings extends Component {
    render() {
        const {title} = this.props
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        return (
            <SettingsGroup title={title}>
                <TagSourceField label="Название магазина" tag="name" required>
                    <InputText
                        value={profile.shop_name}
                        onChange={e => profile.shop_name = e.target.value}
                        state={context.form_state}
                    />
                    <Hint>Короткое название магазина. Должно совпадать с фактическим названием, которое публикуется на
                        сайте.</Hint>
                </TagSourceField>

                <TagSourceField label="Компания" tag="company" required>
                    <InputText
                        value={profile.shop_company}
                        onChange={e => profile.shop_company = e.target.value}
                        state={context.form_state}
                    />
                    <Hint>Полное наименование компании, владеющей магазином. Не публикуется, используется для внутренней
                        идентификации</Hint>
                </TagSourceField>

                <TagSourceField label="Наименование агентства" tag="agency">
                    <InputText
                        value={profile.shop_agency}
                        onChange={e => profile.shop_agency = e.target.value}
                        state={context.form_state}
                    />
                    <Hint>Агенство, которое оказывает техническую поддержку магазину и отвечает за работоспособность
                        сайта.</Hint>
                </TagSourceField>

                <TagSourceField label="Контактный email" tag="email">
                    <InputText
                        value={profile.shop_email}
                        onChange={e => profile.shop_email = e.target.value}
                        state={context.form_state}
                    />
                    <Hint>Адрес разработчиков CMS или агентства, осуществляющего техподдержку</Hint>
                </TagSourceField>

                <TagSourceField label="Валюта" tag="currencies">
                    <DependentCheckbox
                        checked={!profile.shop_enable_currency}
                        onChange={e => profile.shop_enable_currency = !e.target.checked}
                        state={context.form_state}
                    >Не передавать информацию о валюте</DependentCheckbox>
                    <Hint>Отметьте чекбокс, если вам нужно убрать элемент {'<currencies>'} из фида выгрузки.</Hint>
                </TagSourceField>

                <TagSourceField label="Часовой пояс" tag={'yml_catalog date=""'}>
                    <DependentCheckbox
                        checked={profile.shop_timezone}
                        onChange={e => profile.shop_timezone = e.target.checked}
                        state={context.form_state}
                    >Передавать часовой пояс</DependentCheckbox>

                </TagSourceField>

                <TagSourceField label="RFC 3339" tag={'yml_catalog date=""'}>
                    <DependentCheckbox
                        checked={profile.shop_rfc3339}
                        onChange={e => profile.shop_rfc3339 = e.target.checked}
                        state={context.form_state}
                    >Использовать формат RFC 3339</DependentCheckbox>
                </TagSourceField>

                <TagSourceField label="RUR" tag={'currency'}>
                    <DependentCheckbox
                        checked={profile.shop_rur_enabled}
                        onChange={e => profile.shop_rur_enabled = e.target.checked}
                        state={context.form_state}
                    >Передавать RUR вместо RUB</DependentCheckbox>

                </TagSourceField>
                <TagSourceField label="Только рубли" tag={'currency'}>
                    <DependentCheckbox
                        checked={profile.shop_rur_only}
                        onChange={e => profile.shop_rur_only = e.target.checked}
                        state={context.form_state}
                    >Выгружать только рубли</DependentCheckbox>

                </TagSourceField>
            </SettingsGroup>
        )
    }
}